var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-switcher p-4px flex-center"},_vm._l((_vm.list),function(t){return _c('div',{staticClass:"option flex-1 flex-center",class:{ checked: t.value === _vm.innerCurrent },on:{"click":function($event){return _vm.whenChange(t)}}},[_vm._v(_vm._s(t.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }